'use client';
import View from '@/components/view';
import { Page, Section } from '@/typings/pages';
import VideoBanner from '@/components/banner/video';
import { extractSection } from '@/lib/find-section';
import MarkDownParser from '@/components/markdown/content';

enum SectionType {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  GALLERY = 'GALLERY',
}
type Props = {
  data: Page | null;
};

const PrivacyPolicyClient = ({ data }: Props) => {
  const first = extractSection(data?.section, SectionType.FIRST) as Section;

  return (
    <>
      <VideoBanner
        heading={data?.banner?.heading}
        source={data?.banner?.video as string}
      />
      <View className="section my-4 sm:my-8">
        <MarkDownParser content={first?.content as string} />
      </View>
    </>
  );
};
export default PrivacyPolicyClient;
